import React from 'react';
import * as styles from '@/components/productPage/tableComponents/ProductPage_style';
import { Box } from '@mui/material';
import { GetResponsiveWidth } from '@/components/common/TabsComponent';
import { useResponsive } from '@/contexts/ResponsiveContext';

interface OutterWrapperBaseProps {
    pathname: string;
    componentName: string;
    breadcrumbsComponent?: React.ReactNode;
    bannerImageUrl?: string;
    pageTitle: string;
    pagesubTitle?: string;
    specialPageSubTitle?: React.ReactNode;
}
type OutterWrapperProps = React.PropsWithChildren<OutterWrapperBaseProps>;

const OutterWrapper: React.FC<OutterWrapperProps> = ({
    pathname,
    componentName,
    breadcrumbsComponent,
    bannerImageUrl,
    pageTitle,
    pagesubTitle,
    specialPageSubTitle,
    children,
}) => {
    const Banner = {
        display: 'flex',
        flexDirection: 'column' as 'column',
        backgroundImage: `linear-gradient(rgba(183, 83, 50, 0.8), rgba(183, 83, 50, 0.8)), url(${bannerImageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        width: '100%',
        color: 'white',
    };

    const { isScreenXs } = useResponsive();

    return (
        <div
            key={pathname}
            style={styles.productPageContainer}
            data-testid={`${componentName}-page`}
        >
            <div style={styles.breadCrumbs} data-testid={`${componentName}-breadCrumbs`}>
                <Box
                    sx={{
                        width: GetResponsiveWidth,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        margin: 'auto',
                    }}
                >
                    {breadcrumbsComponent}
                </Box>
            </div>
            <div style={Banner} data-testid={`${componentName}-banner`}>
                <Box
                    sx={{
                        width: GetResponsiveWidth,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        margin: 'auto',
                        height: '180px',
                    }}
                >
                    <h1
                        style={{
                            ...styles.bannerFont,
                            fontSize: isScreenXs ? '22px' : styles.bannerFont.fontSize,
                            marginBottom: isScreenXs ? '6px' : styles.bannerFont.marginBottom,
                        }}
                    >
                        {pageTitle}
                    </h1>
                    <span
                        style={{
                            ...styles.bannerFont2,
                            fontSize: isScreenXs ? '14px' : styles.bannerFont2.fontSize,
                            marginBottom: '2px',
                        }}
                    >
                        {specialPageSubTitle ?? pagesubTitle}
                    </span>
                </Box>
            </div>
            {children}
        </div>
    );
};

export default OutterWrapper;
